module.exports = __webpack_public_path__ + "static/media/27858938_1966554446941651_2542729163554927824_n.7be10040.jpg";